import React, { useEffect, useState } from "react";
import "./Mid-Section-Pc.scss";

//import components
import { ToastContainer, Zoom } from "react-toastify";
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";
import DonutPercentage from "../../OverView/Pc-and-Large-Screens/DonutPercentage.jsx";
import TenantTable from "./TenantTable.jsx";

//import icons
import { IoPersonAddOutline } from "react-icons/io5";
import { CgArrowsExchange } from "react-icons/cg";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { CiEdit } from "react-icons/ci";
import TenantModificationModal from "../Mobile-and-Tablet/TenantModal.jsx";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { IoIosAddCircle } from "react-icons/io";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import {
  fetchTenants,
  getAllHouses,
  getAllProperties,
} from "../../../../redux/slices/sliceActions";
import customToasts from "../../../assets/reusableComponents/myToasts.jsx";

const MidSectionTenants = () => {
  // redux methods
  const dispatch = useDispatch();

  // data fetched from the store
  const { tenants, properties } = useSelector((state) => state.landlordslice);
  const [selectedPropertyId, setSelectedPropertyId] = useState(
    properties[0]?._id
  );
  const [selectedProperty, setSelectedProperty] = useState(properties[0]);
  useEffect(() => {
    dispatch(getAllProperties());
  }, []);
  useEffect(() => {
    if (selectedPropertyId) {
      console.log("changes", selectedPropertyId);
      dispatch(getAllHouses({ id: selectedPropertyId }));
      dispatch(fetchTenants({ property_id: selectedPropertyId }));
      const property = properties.find(
        (property) => property._id === selectedPropertyId
      );
      setSelectedProperty(property);
      console.log("here", property);
    }
  }, [properties, selectedPropertyId]);

  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const [tenantData, setTenantData] = useState({});
  const [newTenantInvoice, setNewTenantInvoice] = useState(null);
  const [selectedHouseId, setSelectedHouseId] = useState("");

  const handleShowModal = (actionType) => {
    // Check if adding a tenant and no vacant houses are available
    if (actionType === "create new tenant") {
      const vacantHouses =
        selectedProperty?.totalHouses - selectedProperty?.occupiedHouses;
      if (vacantHouses <= 0) {
        customToasts.error(
          "No vacant houses available. Create new houses or vacate tenant first"
        );
        return;
      }
    }

    setAction(actionType);
    setShowModal(true);
  };

  return (
    <div className="mid-section-Tenants-pc">
      <div className="title">
        Tenant Information
        <div className="description">Manage your tenant information</div>
      </div>
      <div className="cards-container">
        <div className="individual-card">
          <div className="top-card-section">
            <div className="top-left">
              <div className="title">Tenant Information</div>
              <div className="number">
                {selectedProperty?.occupiedHouses} Tenants
              </div>
              {/* <div className="date">
                <MonthYearPicker />
              </div> */}
            </div>
            <div className="top-right">
              <div className="apartment">
                <select
                  id="apartment-select"
                  name="apartment"
                  className="apartment-dropdown"
                  onChange={(e) => setSelectedPropertyId(e.target.value)}
                >
                  {properties?.map((property, index) => {
                    return (
                      <option key={index} value={property._id}>
                        {property.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
          <div className="bottom-card-section">
            <div className="bottom-left">
              <DonutPercentage
                percentage={
                  (
                    (selectedProperty?.occupiedHouses /
                      selectedProperty?.totalHouses) *
                    100
                  ).toFixed(1) || 0
                }
                donutSize={"80%"}
                setColors={["#192A3A", "#B39359"]}
              />
            </div>
            <div className="bottom-right">
              <div className="section">
                <div className="shape-and-text">
                  <div className="shape"></div>
                  <div className="title-and-details">
                    <div className="title">Occupied Houses</div>
                    <div className="details">
                      {selectedProperty?.occupiedHouses}
                    </div>
                  </div>
                </div>
                <div className="shape-container">
                  <div
                    className="shape-2"
                    style={{
                      width: `${
                        ((selectedProperty?.occupiedHouses /
                          selectedProperty?.totalHouses) *
                          60 || 0) + 1
                      }px`,
                    }}
                  ></div>
                  <div className="text">
                    {(
                      (selectedProperty?.occupiedHouses /
                        selectedProperty?.totalHouses) *
                      100
                    ).toFixed(1) || 0}{" "}
                    %
                  </div>
                </div>
              </div>
              <div className="section second-section">
                <div className="shape-and-text">
                  <div className="shape"></div>
                  <div className="title-and-details">
                    <div className="title">Vacant Houses</div>
                    <div className="details">
                      {selectedProperty?.totalHouses -
                        selectedProperty?.occupiedHouses}
                    </div>
                  </div>
                </div>
                <div className="shape-container">
                  <div
                    className="shape-2"
                    style={{
                      width: `${
                        (((selectedProperty?.totalHouses -
                          selectedProperty?.occupiedHouses) /
                          selectedProperty?.totalHouses) *
                          60 || 0) + 1
                      }px`,
                    }}
                  ></div>
                  <div className="text">
                    {(
                      ((selectedProperty?.totalHouses -
                        selectedProperty?.occupiedHouses) /
                        selectedProperty?.totalHouses) *
                      100
                    ).toFixed(1) || 0}{" "}
                    %
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="individual-card progress-report-card">
          <div className="title">Payments Progress</div>
          <div className="progress">
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Rent</div>
                <div className="shape">
                  <div style={{ height: "100%", width: "70%" }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#192A3A",
                        height: "100%",
                        width: "100%",
                        borderRadius: vw(5),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">15,000</div>
            </div>
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Rent</div>
                <div className="shape">
                  <div style={{ height: "100%", width: "30%" }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#B39359",
                        height: "100%",
                        width: "100%",
                        borderRadius: vw(5),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">25,000</div>
            </div>
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Rent</div>
                <div className="shape">
                  <div style={{ height: "100%", width: "45%" }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#64A371",
                        height: "100%",
                        width: "100%",
                        borderRadius: vw(5),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">6,000</div>
            </div>
          </div>
          <div className="boundery">
            <div className="amount">0%</div>
            <div className="amount">25%</div>
            <div className="amount">50%</div>
            <div className="amount">75%</div>
            <div className="amount">100%</div>
          </div>
        </div>
        <div className="individual-card actions-container">
          <div className="title">Actions </div>
          <div className="options-container">
            <div
              className="option"
              onClick={() => handleShowModal("create new tenant")}
            >
              <div className="icon-container">
                <IoPersonAddOutline />
              </div>
              <div className="text">Add</div>
            </div>
            <div
              className="option alternate-option"
              onClick={() => handleShowModal("modify tenant")}
            >
              <div className="icon-container">
                <CiEdit />
              </div>
              <div className="text">Edit</div>
            </div>
            <div
              className="option alternate-option"
              onClick={() => handleShowModal("move tenant")}
            >
              <div className="icon-container">
                <CgArrowsExchange />
              </div>
              <div className="text">Relocate</div>
            </div>
            <div
              className="option"
              onClick={() => handleShowModal("delete tenant")}
            >
              <div className="icon-container">
                <IoPersonRemoveOutline />
              </div>
              <div className="text">Remove</div>
            </div>
          </div>
        </div>
      </div>
      {tenants?.length > 0 ? (
        <div className="tenant-table-container">
          <div className="description" style={{ margin: `${vh(20)} 0px` }}>
            Tenant List
          </div>
          <TenantTable
            handleShowModal={handleShowModal}
            setTenantData={setTenantData}
            setSelectedHouseId={setSelectedHouseId}
            setNewTenantInvoice={setNewTenantInvoice}
          />
        </div>
      ) : (
        <div
          className="no-tenants"
          onClick={() => handleShowModal("create new tenant")}
        >
          <div className="icon">
            <IoPersonAddOutline fontSize={50} />
            {/* <IoIosAddCircle fontSize={50} className="add-icon"/> */}
          </div>
          <div className="title">Tenants</div>
          <div className="sub-title">No Tenants yet</div>
        </div>
      )}

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />

      {showModal && (
        <>
          <TenantModificationModal
            setShowPay={setShowModal}
            fieldToShow={action}
            tenantData={tenantData}
            setTenantData={setTenantData}
            handleShowModal={handleShowModal}
            selectedPropertyId={selectedPropertyId}
            selectedHouseId={selectedHouseId}
            setSelectedHouseId={setSelectedHouseId}
            newTenantInvoice={newTenantInvoice}
          />
        </>
      )}
    </div>
  );
};

export default MidSectionTenants;
